import { useEffect, useState } from "react";

import { observer } from "mobx-react";

import { INFERENCE_STATE, InferenceState } from "../hooks/useFile";
import { useImageRendering } from "../hooks/useImageRendering";
import { ImageViewToolbar } from "../molecules/image-viewer/ImageViewToolbar";
import ParsingImageView from "../molecules/ParsingImageView";
import { ImageOacJson } from "../types/demo";
import { imageViewStore } from "../utils/mobx/ImageViewStore";
import { resultInteractionStore } from "../utils/mobx/ResultInteractionStore";

export interface DemoImageViewProps {
  file: ImageOacJson;
  page: number;
  isDRSP: boolean;
  pageSelectHandler: (page: number) => void;
  image: string;
  imageScale: number;
  imageScaleChangeHandler: (scale: number) => void;
  numberOfImages: number;
  allowBoxClick?: boolean;
  inferenceState?: InferenceState;
}

const ValidatorImageView = ({
  file,
  page,
  isDRSP,
  pageSelectHandler,
  image,
  imageScale,
  imageScaleChangeHandler,
  numberOfImages,
  allowBoxClick = true,
  inferenceState = INFERENCE_STATE.IDLE,
}: DemoImageViewProps): JSX.Element => {
  const [cssTransform, setCssTanform] = useState<string>("");
  const { reset, setReset, degree, setDegree } = imageViewStore;
  const {
    canvasSizeChangeHandler,
    canvasObjectMoveHandler,
    imageSizeChangeHandler,
    rotateBy,
    moveAndFocus,
  } = useImageRendering(
    file,
    imageScale,
    reset,
    imageScaleChangeHandler,
    setCssTanform,
  );

  const { setHoveredBoxIds, setSelectedBoxIds, setFocusIndex } =
    resultInteractionStore;
  const [imageSelectedBoxIds, setImageSelectedBoxIds] = useState<string[]>([]);
  const [imageHoveredBoxIds, setImageHoveredBoxIds] = useState<string[]>([]);
  useEffect(() => {
    setDegree(0);
  }, [file, setDegree]);

  return (
    <>
      <div className={"flex-1"}>
        <div
          className="relative flex h-full flex-col justify-between"
          onClick={() => {
            setSelectedBoxIds([]);
            setHoveredBoxIds([]);
            setImageSelectedBoxIds([]);
            setImageHoveredBoxIds([]);
            setFocusIndex(-1);
          }}
        >
          {/* 이미지 뷰 섹션 */}
          <ParsingImageView
            image={image}
            allowBoxClick={allowBoxClick}
            cssTransform={cssTransform}
            onResizeCanvas={canvasSizeChangeHandler}
            onMoveImage={canvasObjectMoveHandler}
            onImageSizeChanged={imageSizeChangeHandler}
            inferenceState={inferenceState}
            page={page}
            isDRSP={isDRSP}
            pageSelectHandler={pageSelectHandler}
            setImageHoveredBoxIds={setImageHoveredBoxIds}
            imageSelectedBoxIds={imageSelectedBoxIds}
            imageHoveredBoxIds={imageHoveredBoxIds}
            moveAndFocus={moveAndFocus}
            numberOfImages={numberOfImages}
            onReset={() => {
              setReset(!reset);
            }}
          />
          {/* 이미지 설정 섹션 */}
          <ImageViewToolbar
            fileVisible={!!image}
            imageScale={imageScale}
            onImageScaleChange={imageScaleChangeHandler}
            numberOfImages={numberOfImages}
            page={page}
            onPageSelect={pageSelectHandler}
            onRotate={() => {
              rotateBy(90);
              setDegree((degree + 90) % 360);
            }}
            // userImageRendering에서 초기화시키키는 useEffect에 reset을 추가하여 작동시킨다.
            onReset={() => {
              setReset(!reset);
            }}
          />
        </div>
      </div>
    </>
  );
};

export default observer(ValidatorImageView);
